import { render, staticRenderFns } from "./view-update-argue.vue?vue&type=template&id=719b75de&scoped=true&lang=pug"
import script from "./view-update-argue.vue?vue&type=script&lang=js"
export * from "./view-update-argue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b75de",
  null
  
)

export default component.exports